import React from 'react';
import cx from 'classnames';
import T from 'i18n-react';

import { ButtonToggle } from '@motorway/mw-highway-code/pre-alpha';

import cypressIds from 'Components/cypress_ids.json';
import ExpandableFilter from 'Components/shared/ExpandableFilter/ExpandableFilter';
import texts from 'Components/texts.json';
import { applyCypressData } from 'Utilities/helpers';

import useFilterView from '../useFilterView';

import styles from '../Filters.module.scss';
import toggleStyles from './CollectionToggle.module.scss';

T.setTexts(texts);

type CollectionToggleViewProps = {
	handleCollectionToggle: () => void;
	id: string;
	isAvailableForCollection: boolean;
};

export const CollectionToggleView: React.FC<CollectionToggleViewProps> = ({
	handleCollectionToggle,
	id,
	isAvailableForCollection,
}) => {
	const { isExpandableFilter } = useFilterView();

	const title = `${T.translate('vehicleList.filters.collection.label')}`;

	// These are chips masquerading as radios, hence the specific controls
	const value = isAvailableForCollection ? 'availableNow' : 'all';
	const onChange = (newValue: string) => {
		if (newValue !== value) {
			handleCollectionToggle();
		}
	};

	const Options = () => (
		<div className={toggleStyles.collectionToggle}>
			<ButtonToggle
				fullWidth
				{...applyCypressData(cypressIds.filters.collection.all)}
				id="collection-all"
				label={T.translate('vehicleList.filters.collection.all')}
				onClick={() => onChange('all')}
				selected={!isAvailableForCollection}
				type="button"
				variant="secondary"
			/>
			<ButtonToggle
				fullWidth
				{...applyCypressData(cypressIds.filters.collection.availableNow)}
				id="collection-available-now"
				label={T.translate('vehicleList.filters.collection.availableNow')}
				onClick={() => onChange('availableNow')}
				selected={isAvailableForCollection}
				type="button"
				variant="secondary"
			/>
		</div>
	);

	return (
		<>
			{isExpandableFilter ? (
				<ExpandableFilter
					classNames={{
						content: styles.expandableCollectionToggle,
						expanded: styles.expandedCollection,
					}}
					id={id}
					isDirty={isAvailableForCollection}
					title={title}
				>
					<Options />
				</ExpandableFilter>
			) : (
				<fieldset className={cx(toggleStyles.toggleGroup, 'mw-mt-3 mw-mb-3')}>
					<legend>{title}</legend>
					<Options />
				</fieldset>
			)}
		</>
	);
};

export default CollectionToggleView;
